export default __webpack_public_path__ + "static/media/othergoal.4cc88b0b.png";